import type { Timestamp } from "firebase/firestore";

type DateLike =
  | Date
  | Timestamp
  | { toDate?: () => Date; seconds?: number }
  | undefined
  | null;

export function toActivityDate(date: DateLike): Date | null {
  if (!date) return null;
  if (date instanceof Date) {
    return Number.isNaN(date.getTime()) ? null : date;
  }
  if (typeof (date as Timestamp).toDate === "function") {
    const parsed = (date as Timestamp).toDate();
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }
  if (typeof (date as { seconds?: number }).seconds === "number") {
    return new Date((date as { seconds: number }).seconds * 1000);
  }
  return null;
}
